import React from "react";
import SearchIcon from "theme/components/icons/SearchIcon";
import SearchInput from "./SearchInput";
import colors from "theme/config/colors";
import hideOverlays from "core-web/state/models/Overlay/dispatches/hideOverlays";
import showOverlay from "core-web/state/models/Overlay/dispatches/showOverlay";
import styled from "theme/libs/styled";
import toggleSearch from "core-web/state/models/Header/dispatches/toggleSearch";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const SearchBarWrapper = styled("div")`
    width: 100%;
    height: 43px;
    background-color: ${({ theme }) => theme.colors.neutral_50};
    border-radius: 100px;
    display: flex;
    align-items: center;
    overflow: hidden;
`;

const ToggleSearch = styled("button")`
    display: grid;
    place-content: center;
    padding: 14px;
`;

const Search = () => {
    const { t } = useTranslation();

    const searchPath =
        useSelector(({ application }) => application.config?.options?.specified_pages?.specified_pages?.search) || "";
    const searchIsOpen = useSelector(({ header }) => header.states.searchIsOpen);

    const openSearchOverlay = () => {
        toggleSearch(true);
        showOverlay("search");
    };

    const closeSearchOverlay = () => {
        toggleSearch(false);
        hideOverlays();
    };

    return (
        <SearchBarWrapper>
            <ToggleSearch onClick={openSearchOverlay} aria-label={t("aria_labels.open_search")}>
                <SearchIcon height="14px" width="14px" color={searchIsOpen ? colors.black : colors.black_50} />
            </ToggleSearch>
            <SearchInput
                maxLength="75"
                searchPath={searchPath}
                isSearchOpen={searchIsOpen}
                closeSearch={closeSearchOverlay}
            />
        </SearchBarWrapper>
    );
};

export default Search;
